import { useState } from "react";
import { CrearEntidadForm, Input } from "@/components/ui";
import { toastError } from "@/lib/toast";
import { useCrearClaveSat } from "../hooks/use-clave-sat-mutations";

export function ClaveSatCrearForm({ onSalir }: { onSalir: () => void }) {
  const [clave, setClave] = useState("");
  const [descripcion, setDescripcion] = useState("");

  const crear = useCrearClaveSat({ onCreado: onSalir });

  const submit = () => {
    if (!clave.trim() || !descripcion.trim()) {
      toastError({ title: "Datos incompletos", message: "Clave y descripción son obligatorios." });
      return;
    }
    crear.mutate({ clave: clave.trim(), descripcion: descripcion.trim() });
  };

  return (
    <CrearEntidadForm
      titulo="Nueva clave SAT"
      descripcion="Captura clave producto/servicio del SAT (8 dígitos) y su descripción."
      onCancelar={onSalir}
      onCrear={submit}
      creando={crear.isPending}
    >
      <Input label="Clave" placeholder="84111506" value={clave} onChange={(e) => setClave(e.currentTarget.value)} maxLength={20} className="font-mono" required />
      <Input label="Descripción" placeholder="Servicios contables" value={descripcion} onChange={(e) => setDescripcion(e.currentTarget.value)} maxLength={400} required />
    </CrearEntidadForm>
  );
}
